import type { BrowserProfileInfo } from '@lub0v/santa-utils';
import { ACCOUNT_PATH, boxPath } from '@src/routing/routes';

/** Where a profile should land after a switch, sign-out, or delete. */
export function profileHomePath(profile?: Pick<BrowserProfileInfo, 'isGuest' | 'boxes'>): string {
  if (profile?.isGuest) {
    const key = profile.boxes?.[0]?.key;
    return key ? boxPath(key) : '/';
  }
  return ACCOUNT_PATH;
}

export function getProfileName(
  profile: BrowserProfileInfo,
  fallback: string,
): string {
  const featuredBox = profile.boxes?.[0];
  return featuredBox?.username || profile.email || featuredBox?.name || fallback;
}

export function getProfileSummary(
  profile: BrowserProfileInfo,
  copy: {
    noBoxes: string;
    organizer: string;
    moreOne: string;
    more: (count: number) => string;
  },
): string {
  const featuredBox = profile.boxes?.[0];
  if (!featuredBox) {
    return copy.noBoxes;
  }
  const organizer = featuredBox.isOrganizer ? ` · ${copy.organizer}` : '';
  const extra = (profile.boxes?.length || 1) - 1;
  const more =
    extra > 0 ? ` · ${extra === 1 ? copy.moreOne : copy.more(extra)}` : '';
  return `${featuredBox.name}${organizer}${more}`;
}
